import { TabNav } from '@repo/ui/Tabs';
import { NavTab } from '@repo/ui/Tabs';

import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { useAccount } from '@/hooks/useAccount';

const MessagingTabNav = () => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;

  const MessagingTabs: (NavTab | null)[] = [
    POLICIES['sms_requests:index'](user) || POLICIES['mms_requests:index'](user)
      ? {
          title: 'Traffic',
          href: `/a/${accountId}/messaging`,
        }
      : null,

    POLICIES['messaging_optout_items:index'](user)
      ? {
          title: 'Opt Outs',
          href: `/a/${accountId}/messaging/opt-outs`,
        }
      : null,
  ];

  return <TabNav tabs={MessagingTabs} />;
};

export default MessagingTabNav;
